/**
 * @file recent-order.component.ts
 */
import { Component, Input, OnInit } from '@angular/core';
import { MailOrder } from '../../interfaces/mail-order.interface';
import { PrescriptionFill } from '../../interfaces/prescription-fill.interface';
import { MultilingualService } from '../../core/services/multilingual/multilingual.service';
import { UserService } from 'src/app/services/user/user.service';
import { MailOrderStatus } from 'src/app/enums/enum';

@Component({
  selector: 'app-recent-order',
  templateUrl: './recent-order.component.html',
  styleUrls: ['./recent-order.component.scss']
})
export class RecentOrderComponent implements OnInit {
  @Input() recentOrder!: MailOrder<PrescriptionFill>;
  @Input() stepNo = 0;
  @Input() showPrescription = true;

  public orderCancelledStatus = MailOrderStatus.CANCELLED;
  public orderPickedUpStatus = MailOrderStatus.PICKED_UP;
  public isOrionUser!: boolean;
  constructor(
    public readonly multilingualService: MultilingualService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.isOrionUser = this.userService.isOrionUser();
   }
}
